// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-2oBnE";
var _4 = "wrapper_return-2U7K9";
var _5 = "leg-1WDVk";
var _6 = "disclaimer-3h6Zw";
var _7 = "controls__wrapper-2FIrL";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "wrapper_return", _5 as "leg", _6 as "disclaimer", _7 as "controls__wrapper" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "wrapper_return": _4, "leg": _5, "disclaimer": _6, "controls__wrapper": _7 }
